module.exports = __webpack_public_path__ + "static/media/26_ManuelGalemann_webfinal.c791c7dc.jpg";